import { useBaseViewModel } from '@/common';
import { CourseEntity } from '@/domains/course/entities';
import { FindCourseUsecase } from '@/domains/course/usecases';
import { useState } from 'react';
import { CourseHttpRepository } from '../adapters/repositories';

export default function GetDetailCourse() {
  const findCourseUC = new FindCourseUsecase(new CourseHttpRepository());
  const { loading, error, catchAction } = useBaseViewModel();
  const [courseData, setCourseData] = useState<CourseEntity>();

  const actionGetDetailCourse = async (id: string) => {
    await catchAction(async () => {
      const data = await findCourseUC.run(id);
      setCourseData(data);
    });
  };

  return {
    loading,
    error,
    courseData,
    actionGetDetailCourse,
  };
}
